export default {
  paymentScheduled: 'SCHEDULED PAYMENT',
  paymentMethodAdded: 'CHOSE A PAYMENT METHOD',
  inviteVisited: 'OPENED INVITE',
  inviteSent: 'INVITED',
};
